/**
 * ServiceTimeService
 * Service for ServiceTime entity operations
 * Route: api/service-times
 * Controller: ServiceTimesController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * ServiceTimeService
 * Handles service time CRUD operations and custom endpoints
 * Maps to /api/service-times endpoint
 */
export class ServiceTimeService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? ServiceTimeService.DEFAULT_SERVICE_PATH,
            basePath: ServiceTimeService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== CUSTOM METHODS ====================
    /**
     * Get all service times for a specific location
     * GET /api/service-times/location/{locationId}
     * @param locationId - Location ID
     * @returns Array of service times
     */
    async getByLocationId(locationId) {
        const response = await this.getByLocationIdRaw(locationId);
        return response.data ?? [];
    }
    /**
     * Get all service times for a specific location (raw)
     * @param locationId - Location ID
     * @returns ResponseData with array of service times
     */
    getByLocationIdRaw(locationId) {
        const endpoint = this.getEndpoint('byLocationId', `location/${locationId}`);
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
}
ServiceTimeService.DEFAULT_SERVICE_PATH = 'locations';
ServiceTimeService.BASE_PATH = 'api/service-times';
//# sourceMappingURL=ServiceTimeService.js.map